import type React from 'react';
import Markdown from 'react-markdown';
import { Box, Typography } from '@mui/material';

import { PAGE_TYPES } from 'src/constants/module';
import useSimpleContentPage from 'src/hooks/useSimpleContentPage';
import TextSkeleton from 'src/components/common/LoadingPage/textSkeleton';

const ContactModalContent: React.FC = () => {
  const { pageContent, error, loading } = useSimpleContentPage(
    PAGE_TYPES.CONTACT,
  );

  return (
    <Box sx={{ px: 4 }}>
      {loading ? (
        <TextSkeleton lineHeight={20} lineLimiter={3.5} />
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <Markdown>{pageContent}</Markdown>
      )}
    </Box>
  );
};

export default ContactModalContent;
